import { render, staticRenderFns } from "./Referrer_EULA_2025_08_28.vue?vue&type=template&id=8861ffc8&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports